var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('new-modal-wrapper', {
    ref: "transferDesignModal",
    attrs: {
      "modal-classes": "transfer-design-modal transfer-design-modal--step-".concat(_vm.step),
      "widthModal": '100%',
      "maxWidthModal": 500,
      "heightModal": _vm.isMobile ? '100%' : 'auto',
      "fullHeight": true,
      "modal-name": "transferDesignComponent",
      "headerTitle": _vm.translations.transferDesignModalTitle,
      "ctaPrimaryButton": "transferDesignModalCta",
      "showCloseIcon": _vm.showCloseIcon
    },
    on: {
      "before-open": _vm.initModal,
      "closed": _vm.onClose,
      "cta-action": function ctaAction($event) {
        return _vm.$refs.transferDesignContent.onContinue();
      }
    }
  }, [_vm.step === 'choose-style' && (!_vm.isLoadingData || _vm.loadExternal3dViewer) ? _c('transfer-design-content', {
    ref: "transferDesignContent",
    on: {
      "showIconButton": _vm.showIconButton,
      "blockCtaPrimaryButton": _vm.blockCtaPrimaryButton,
      "showCtaPrimaryButton": _vm.showCtaPrimaryButton,
      "continue": _vm.goToTransferStyleStep,
      "showCloseIcon": _vm.onShowCloseIcon,
      "updateLoadingData": _vm.updateLoadingData
    }
  }) : _vm.step === 'transfer-style' ? _c('section', {
    staticClass: "transfer-design--wrapper content modal-scroll-area"
  }, [_c('p', {
    staticClass: "transfer-design--description"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.transferDesignLoadingText) + "\n    ")])]) : _vm._e(), _c('div', {
    staticClass: "loader__wrapper transfer-design-modal__spinner-wrapper"
  }, [_c('loading-spinner', {
    ref: "spinner",
    attrs: {
      "show-spinner-default": _vm.showSpinner,
      "displayText": "translations.transferDesignLoadingText"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }